import { ListWithLabel } from "@/components/list";
import Img1 from "public/iaas/costEfficient.4c199bb4.svg";
import Img2 from "public/iaas/wordpress-service.2952b864.svg";

export const LEVELS_CONSTANTS = {
  title: "Load Balancing Levels ",
  list: [
    {
      image: Img1,
      title: "Infrastructure-Level Load Balancing :",
      content: (
        <ListWithLabel
          points={[
            {
              label: "Shared Load Balancer (SLB)",
              text: "Acts as the primary entry point for external HTTP/HTTPS traffic, routing requests to your applications running in the cloud environment.",
            },
            {
              label: "Routing via Public IP",
              text: "Direct IP-based access bypasses SLB, allowing static IP routing for services like VPNs or specific ports.",
            },
            {
              label: "NGINX Proxy Layer",
              text: "Uses NGINX as a reverse proxy to distribute load across application instances while handling SSL termination.",
            },
            {
              label: "Auto Health Checks",
              text: "Continuously monitors backend service availability, ensuring traffic is only sent to healthy and responsive instances.",
            },
          ]}
        />
      ),
    },
    {
      image: Img2,
      title: "Application-Level Load Balancing ",
      content: (
        <ListWithLabel
          points={[
            {
              label: "NGINX",
              text: "Open-source reverse proxy and load balancer providing Layer 7 routing, SSL support, rate limiting, and static file caching.",
            },
            {
              label: "HAProxy",
              text: "Advanced TCP/HTTP load balancer offering high availability and fine-tuned control over session handling and failover.",
            },
            {
              label: "Apache HTTP Server",
              text: "Supports load balancing via mod_proxy and mod_balancer modules, enabling backend pool management and traffic shaping.",
            },
            {
              label: "LiteSpeed Web ADC",
              text: "A commercial solution with Layer 7 features, built-in security filtering, HTTP/3 support, and anti-DDoS capabilities.",
            },
          ]}
        />
      ),
      conclusion:
        "NOTE : The cost is absorbed by the VM. There is no additional charge for using this feature with our setup.",
    },
  ],
};
